// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__cSI7L","primary":"Button_primary__nHGn_","secondary":"Button_secondary__vpKzd","tertiary":"Button_tertiary__93jUn"};